<template>
	<div class="animate__animated animate__fadeIn" data-wow-duration="0.8s">
		<!-- 路由导航 -->
		<div class="routerDh f-bct">
			<div class="l f-ct">
				<div class="t1">当前位置：</div>
				<!-- 课程中心
				<el-image :src="require('@/static/icon55.png')"></el-image>
				<div class="t1">课程详情</div>
				<el-image :src="require('@/static/icon55.png')"></el-image> -->
				<div class="t2">填写申报表</div>
			</div>
			<div class="r f-ct" @click="back()">
				<div class="t2">返回课程详情</div>
				<el-image :src="require('@/static/icon56.png')"></el-image>
			</div>
		</div>
		<!-- 表单 -->
		<div class="fromBox">
			<div class="bigTit">
				海南省燃气经营企业从业人员专业培训考核申请表
			</div>
			<!-- 表单 -->
			<div class="from flex">
				<div class="l">
					<!-- 姓名/性别/出生日期 -->
					<div class="f-bct">
						<div class="iptBox w1">
							<div class="lable">姓名</div>
							<div class="ipt">
								<el-input type="text" v-model="name" placeholder="请输入姓名"></el-input>
							</div>
						</div>
						<div class="iptBox w1">
							<div class="lable">姓别</div>
							<div class="ipt radio f-ct">
								<el-radio-group v-model="gender">
									<el-radio :label="1">男</el-radio>
									<el-radio :label="2">女</el-radio>
								</el-radio-group>
							</div>
						</div>
						<div class="iptBox w1">
							<div class="lable">出生日期</div>
							<div class="ipt">
								<el-date-picker
								v-model="birthday"
								type="date"
								value-format="yyyy-MM-dd"
								placeholder="选择日期">
								</el-date-picker>
								<!-- <el-input type="text" v-model="birthday" placeholder="请输入出生日期"></el-input> -->
							</div>
						</div>
					</div>
					<!-- 学历/职称 -->
					<div class="f-bct">
						<div class="iptBox w2">
							<div class="lable">学历</div>
							<div class="ipt">
								<el-input type="text" v-model="educationName" placeholder="请输入学历"></el-input>
							</div>
						</div>
						<div class="iptBox w2">
							<div class="lable">职称</div>
							<div class="ipt">
								<el-input type="text" v-model="jobName" placeholder="请输入职称"></el-input>
							</div>
						</div>
					</div>
					<!-- 职务/申请类别 -->
					<div class="f-bct">
						<div class="iptBox w2">
							<div class="lable">职务</div>
							<div class="ipt">
								<el-input type="text" v-model="positionName" placeholder="请输入职务"></el-input>
							</div>
						</div>
						<div class="iptBox w2">
							<div class="lable">申请类别</div>
							<div class="ipt">
								<el-cascader
								disabled
								style="width: 100%;"
								placeholder="请选择您的申请类别"
								:props="{children:'childList',label:'categoryName',value:'id'}"
								v-model="catVar"
								:options="catArr"></el-cascader>
							</div>
						</div>
					</div>
					<!-- 受聘单位/单位联系人/单位联系人电话 -->
					<div class="f-bct">
						<div class="iptBox w1">
							<div class="lable">受聘单位</div>
							<div class="ipt">
								<el-input type="text" :disabled="true" v-model="companyName" placeholder="请输入受聘单位"></el-input>
							</div>
						</div>
						<div class="iptBox w1">
							<div class="lable">单位联系人</div>
							<div class="ipt">
								<el-input type="text" v-model="companyContact" placeholder="请输入单位联系人"></el-input>
							</div>
						</div>
						<div class="iptBox w1">
							<div class="lable">单位联系人电话</div>
							<div class="ipt">
								<el-input type="text" v-model="companyMobile" placeholder="请输入单位联系人电话"></el-input>
							</div>
						</div>
					</div>
				</div>
				<div class="rimgBox flex">
					<div class="uimg">
						<div class="imgTit">照片（彩色一寸照免冠两张）</div>
						<!-- <el-image fit="cover" :src="require('@/static/img5.png')"></el-image> -->
						<el-upload accept="image/png, image/jpeg" 
						class="avatar-uploader"
						:action="uplink"
						:show-file-list="false"
						:on-change="portraitF">
							<!-- <el-image v-if="!portrait" :src="require('@/static/icon7.png')"></el-image> -->
							<el-image fit="cover" :src="portrait"></el-image>
						</el-upload>
					</div>
					<div class="uimg2" v-if="isRecheck">
						<div class="imgTit">原证书图片（五年有效期内）</div>
						<!-- <el-image fit="cover" :src="require('@/static/img5.png')"></el-image> -->
						<el-upload accept="image/png, image/jpeg" 
						class="avatar-uploader"
						:action="uplink"
						:show-file-list="false"
						:on-change="originCertificateImageF">
							<el-image v-if="!originCertificateImage" :src="require('@/static/icon7.png')"></el-image>
							<el-image v-else fit="cover" :src="originCertificateImage"></el-image>
						</el-upload>
					</div>
				</div>
			</div>
			<div class="from f-ct">
				<div class="iptBox w2">
					<div class="lable">省市区</div>
					<div class="ipt" v-if="regionList.length">
						<el-cascader
						style="width: 100%;"
						placeholder="请选择地址"
						:props="{children:'childList',label:'name',value:'id'}"
						v-model="regionVal"
						:options="regionList"></el-cascader>
					</div>
				</div>
				<div class="iptBox w2">
					<div class="lable">详细地址</div>
					<div class="ipt">
						<el-input type="text" v-model="address" placeholder="请输入详细地址"></el-input>
					</div>
				</div>
				<div class="iptBox w2">
					<div class="lable" style="opacity: 0;">1</div>
					<div class="sel f-ct">
						<div class="selitm f-ct" @click="certificateGrantMethod=1">
							<el-image v-if="certificateGrantMethod==1" :src="require('@/static/icon61.png')"></el-image>
							<el-image v-else :src="require('@/static/icon60.png')"></el-image>
							<p>邮寄</p>
						</div>
						<div class="selitm f-ct" @click="certificateGrantMethod=2">
							<el-image v-if="certificateGrantMethod==2" :src="require('@/static/icon61.png')"></el-image>
							<el-image v-else :src="require('@/static/icon60.png')"></el-image>
							<p>自取</p>
						</div>
					</div>
				</div>
			</div>
			<div class="from f-ct">
				<div class="iptBox w3">
					<div class="lable">个人健康承诺</div>
					<div class="iptxt">
						<el-input type="textarea" v-model="cnTxt" placeholder="请输入个人健康承诺"></el-input>
					</div>
				</div>
			</div>
			<!-- 按钮 -->
			<div class="btnBox flex">
				<div class="b1" @click="back()">取消报名</div>
				<div class="b2" @click="openQM">签名</div>
			</div>
		</div>
		<!-- 弹出框 -->
		<div class="maskBg" @click="hbQianmin=false" v-if="hbQianmin"></div>
		<div class="subTips" v-if="hbQianmin">
			<div class="hbTit f-bct">
				<p>签名</p>
				<el-image class="cha" @click="hbQianmin=false" :src="require('@/static/icon57.png')"></el-image>
			</div>
			<div class="qianMin" v-if="!signatureImage">
				<vue-esign
				ref="esign"
				style="border: 1px dashed #c2c1c1;"
				:height="360"
				/>
			</div>
			<div class="qianMin" v-if="signatureImage">
				<el-image  :src="signatureImage"></el-image>
			</div>
			<div class="t1">提示：请用在虚线内签名</div>
			<div class="hbbtnBox f-ct">
				<div class="b1" @click="signatureImage='',handleReset()">重写</div>
				<div class="b2" @click="handleGenerate">确定</div>
			</div>
		</div>
		<!-- 结束 -->
		<!-- <vue-esign
		ref="esign"
		style="border: 1px dashed #c2c1c1;"
		:height="700"
		:isCrop="isCrop"
		:lineWidth="lineWidth"
		:lineColor="lineColor"
		:bgColor.sync="bgColor"
		/>
		<div class="control-sign">
		<button @click="handleReset">清空画板</button> 
		<button @click="handleGenerate">生成图片</button>
		</div> -->
	</div>
</template>
<script>
import { courseOrdercreate,
authMemberInfo,
regioncityTree,
coursecategoryList,
membermemberDetail,
authCompanyInfo
} from "/src/api/api.js"
// 引入axios
import axios from "axios";
import vueEsign from 'vue-esign'
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	components: { vueEsign },
	data(){
		return {
			id:0,
			hbQianmin:false,
			isRecheck:0,
			categoryId:0,
			// 用户信息
			manInfo:'',
			// 表单
			// 申请类别
			catArr:[],
			catVar:'',
			// 地址
			regionList:[],
			regionVal:'',
			// 其他
			name:'',
			gender: 1,
			birthday:'',
			educationName:'',
			jobName:'',
			positionName:'',
			companyName:'',
			companyContact:'',
			companyMobile:'',
			address:'',
			certificateGrantMethod:1,
			portrait:'',
			originCertificateImage:'',
			cnTxt:'本人身体健康，无妨碍从事相应燃气作业的疾病和生理缺陷。本人对以上信息的真实性负责，如有隐瞒，相关责任全部由本人承担。',
			signatureImage:'',
		}
	},
	mounted() {
		// 获取浏览路径
		if (localStorage.getItem('pageHistory')) {
			var arr = localStorage.getItem('pageHistory')
			arr = JSON.parse(arr)
			this.pageHistory = arr
		}
		// 参数
		this.id = this.$route.query.id
		this.isRecheck = this.$route.query.isRecheck*1||0
		this.categoryId = this.$route.query.categoryId*1||0
		// 获取信息
		this.regioncityTree()
		this.coursecategoryList()
		setTimeout(()=>{
			this.getinfo()
		},500)
	},
	methods:{
		// 打开签名
		openQM(){
			if(!this.companyContact){this.Tips('请输入单位联系人','error');return}
			if(this.isRecheck){
				if(!this.originCertificateImage){this.Tips('请上传原证书图片','error');return}
			}
			if(!this.checkModbile(this.companyMobile)){
				this.Tips('请输入正确的单位联系人电话','error')
				return
			}
			if(this.certificateGrantMethod==1){
				if(!this.regionVal){this.Tips('请选择省市区','error');return}
				if(!this.address){this.Tips('请输入详细地址','error');return}
			}
			this.hbQianmin = true
		},
		// 创建订单
		async courseOrdercreate(){
			if(!this.signatureImage){this.Tips('请先签名','error');return}
			var data = {
				name:this.name,
				gender:this.gender,
				birthday:this.birthday,
				educationName:this.educationName,
				jobName:this.jobName,
				positionName:this.positionName,
				companyName:this.companyName,
				companyContact:this.companyContact,
				companyMobile:this.companyMobile,
				address:this.address,
				certificateGrantMethod:this.certificateGrantMethod,
				portrait:this.portrait,
				originCertificateImage:this.originCertificateImage,
				isRecheck:this.isRecheck,
				signatureImage:this.signatureImage,
				courseCategoryId:this.catVar[1],
				provinceId:this.regionVal[0],
				cityId:this.regionVal[1],
				districtId:this.regionVal[2],
				memberId:this.id,
			}
			localStorage.setItem("manFromAdta", JSON.stringify(data));
			this.back()
			// let res = await courseOrdercreate(data);
			// if(res.code==200){
			// 	this.hbQianmin = false
			// 	this.Tips(res.msg,'success')
			// 	setTimeout(()=>{
			// 		this.link('/userCoursePay',{id:res.data.id})
			// 	},1500)
			// }else{this.Tips(res.msg,'error')}
		},
		// 头像
		portraitF(file) {
			if(file.response){
				this.portrait = file.response.data.url;
			}
		},
		// 原证书图片
		originCertificateImageF(file) {
			if(file.response){
				this.originCertificateImage = file.response.data.url;
			}
		},
		// 获取用户信息 企业
		async getinfoqq(){
			let res;
			res = await authCompanyInfo({});
			if(res.code==200){
				this.companyContact = res.data.company.contact
				this.companyMobile = res.data.company.mobile
			}else{this.Tips(res.msg,'error')}
		},
		// 获取用户信息
		async getinfo(){
			let res;
			res = await membermemberDetail({memberId:this.id});
			if(res.code==200){
				this.manInfo = res.data
				if(this.manInfo.provinceId){
					this.regionVal = [this.manInfo.provinceId,this.manInfo.cityId,this.manInfo.districtId]
				}
				// this.manInfo.courseCategoryId
				for(var i in this.catArr){
					for(var j in this.catArr[i].childList){
						if(this.catArr[i].childList[j].id==this.categoryId){
							this.catVar = [this.catArr[i].id,this.categoryId]
						}
					}
				}
				this.name = this.manInfo.name
				this.signatureImage = this.manInfo.signatureImage
				this.gender = this.manInfo.gender*1
				this.birthday = this.manInfo.birthday
				this.educationName = this.manInfo.educationName
				this.jobName = this.manInfo.jobName
				this.positionName = this.manInfo.positionName
				this.companyName = this.manInfo.companyName
				this.portrait = this.manInfo.portrait
				if(this.manInfo.address){
					this.address = this.manInfo.address
				}
				this.getinfoqq()
			}else{this.Tips(res.msg,'error')}
		},
		// 获取tree结构的列表
		async regioncityTree(){
			let res = await regioncityTree({});
			if(res.code==200){
				this.regionList = res.data
			}else{this.Tips(res.msg,'error')}
		},
		// 获取课程分类
		async coursecategoryList(){
			let res = await coursecategoryList({});
			if(res.code==200){
				var catIdx = []
				res.data.categoryList.forEach((item)=>{
					item.childList = [{
						id:item.id,
						categoryName:'全部',
					},...item.childList]
				})
				for(var i in res.data.categoryList){
					for(var j in res.data.categoryList[i].childList){
						delete res.data.categoryList[i].childList[j]['childList'];
					}
				}
				this.catArr = res.data.categoryList
			}else{this.Tips(res.msg,'error')}
		},
		//清空画板..
		handleReset() {
			this.$refs.esign.reset();
			this.resultImg = "";
		},
		//生成签名图片..
		handleGenerate() {
			if(this.signatureImage){
				this.courseOrdercreate()
				return
			}
			this.$refs.esign.generate().then(res => {
				let fileName = "img1.png";
				let file = this.dataURLtoFile(res, fileName);
				console.log("file", file);
				this.upImg(file)
			}).catch(err => {
				this.Tips('请先签名','error')
				// alert(err) // 画布没有签字时会执行这里 'Not Signned'
			})
		},
		async upImg(file){
			var that = this
			try {
				const response = await axios.post(this.uplink, {file}, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				});
				// this.uploadStatus = '上传成功！';
				this.signatureImage = response.data.data.url; // 假设API返回图片URL
				that.courseOrdercreate()
			} catch (error) {
				// console.error('上传失败:', error);
				// this.uploadStatus = '上传失败: ' + (error.response?.data?.message || error.message);
			}
		},
		//将图片base64转换为文件
		dataURLtoFile(dataurl, filename) {
			var arr = dataurl.split(","),
			mime = arr[0].match(/:(.*?);/)[1],
			bstr = atob(arr[1]),
			n = bstr.length,
			u8arr = new Uint8Array(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new File([u8arr], filename, { type: mime });
		},
		checkModbile(mobile) {
			var re = /^1[3,4,5,6,7,8,9][0-9]{9}$/;
			var result = re.test(mobile); 
			if(!result) {
				return false;//若手机号码格式不正确则返回false
				}
			return true;
		},
	},
	computed:{
		...mapState('userMsg',['userInfo','userType']),
	}
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
.routerDh{
	margin: 0 40px;
	margin-bottom: 24px;
	.l{
		.t1{
			font-size: 16px;
			color: #9A9DA7;
			cursor: pointer;
		}
		.el-image{
			width: 16px;
			height: 16px;
			margin: 0 2px;
		}
		.t2{
			font-size: 16px;
			color: #3B6492;
		}
	}
	.r{
		cursor: pointer;
		.t2{
			font-size: 16px;
			color: #3B6492;
		}
		.el-image{
			width: 18px;
			height: 18px;
			margin-left: 6px;
		}
	}
}
.fromBox{
	margin: 0 40px;
	background: #fff;
	border-radius: 40px;
	padding: 0 32px;
	padding-bottom: 41px;
	.bigTit{
		width: 100%;
		border-bottom: 1px solid #DDDDDD;
		position: relative;
		font-size: 24px;
		color: #3B6492;
		font-weight: bold;
		text-align: center;
		padding-top: 28px;
		padding-bottom: 23px;
		&::after{
			content: '';
			position: absolute;
			width: 72px;
			height: 4px;
			background: #3B6492;
			border-radius: 10px;
			bottom: 0;
			left: 50%;
			transform: translateX(-50%);
		}
	}
	.from{
		align-items: stretch;
		justify-content: space-between;
		.l{
			width: 995px;
		}
		.w1{
			width: 308px;
		}
		.w2{
			width: 480px;
		}
		.w3{
			width: 1510px;
		}
		.iptBox{
			.lable{
				font-size: 16px;
				padding-top: 32px;
				padding-bottom: 12px;
			}
			.addr{
				.selAddrItm{
					width: 150px;
					height: 46px;
					border-radius: 6px;
					border: 1px solid #E8EDF4;
					background: #FBFCFF;
					.el-select{
						width: 100%;
					}
					::v-deep .el-input__inner{
						border: none;
						height: 46px;
						background: transparent;
					}
				}
			}
			.ipt{
				width: 100%;
				height: 46px;
				border-radius: 6px;
				border: 1px solid #E8EDF4;
				background: #FBFCFF;
				.el-input{
					width: 100%;
					height: 46px;
				}
				.el-select{
					width: 100%;
				}
				::v-deep .el-input__inner{
					border: none;
					height: 46px;
					background: transparent;
				}
			}
			.radio{
				padding-left: 20px;
			}
			.sel{
				width: 100%;
				height: 46px;
				.selitm{
					margin-right: 20px;
					cursor: pointer;
					.el-image{
						width: 20px;
						height: 20px;
						margin-right: 6px;
					}
					p{
						font-size: 16px;
						color: #2F3541;
					}
				}
			}
			.iptxt{
				width: 100%;
				height: 140px;
				border-radius: 6px;
				border: 1px solid #E8EDF4;
				background: #FBFCFF;
				.el-textarea{
					width: 100%;
					height: 140px;
				}
				::v-deep .el-textarea__inner{
					border: none;
					height: 140px;
					background: transparent;
					padding-top: 16px;
				}
			}
		}
		.rimgBox{
			width: calc(100% - 1030px);
			padding-top: 30px;
			justify-content: space-between;
			padding-right: 20px;
			.uimg{
				.imgTit{
					font-size: 16px;
					color: #3B3C3E;
					font-weight: bold;
				}
				.el-image{
					width: 190px;
					height: 270px;
					border-radius: 6px;
					margin-top: 11px;
				}
			}
			.uimg2{
				.imgTit{
					font-size: 16px;
					color: #3B3C3E;
					font-weight: bold;
				}
				.el-image{
					width: 190px;
					height: 190px;
					border-radius: 6px;
					margin-top: 11px;
				}
			}
		}
	}
	.btnBox{
		margin-top: 32px;
		justify-content: flex-end;
		div{
			width: 162px;
			height: 46px;
			border-radius: 6px;
			text-align: center;
			line-height: 46px;
			font-size: 16px;
			cursor: pointer;
		}
		.b1{
			// background: #E9F6FF;
			color: #3B6492;
			text-align: right;
			padding-right: 20px;
		}
		.b2{
			background: #3B6492;
			color: #fff;
			margin-left: 14px;
		}
	}
}
.maskBg{
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.4);
	z-index: 10;
}
.subTips{
	position: fixed;
	width: 662px;
	// height: 364px;
	padding-bottom: 34px;
	background: #fff;
	border-radius: 8px;
	z-index: 11;
	top: 50%;
	left: 50%;
	transform: translateX(-50%)translateY(-50%);
	.hbTit{
		width: 662px;
		height: 69px;
		padding-left: 30px;
		padding-right: 32px;
		background: #FAFBFC;
		border-radius: 8px 8px 0 0;
		p{
			font-size: 18px;
			color: #2F3541;
		}
		.cha{
			width: 14px;
			height: 14px;
		}
	}
	.qianMin{
		width: 598px;
		height: 270px;
		border: 1px dashed #D9D9D9;
		border-radius: 11px;
		margin: auto;
		margin-top: 32px;
		overflow: scroll;
	}
	.t1{
		font-size: 16px;
		color: #333333;
		padding-left: 40px;
		margin-top: 18px;
	}
	.hbbtnBox{
		margin-top: 28px;
		justify-content: center;
		div{
			width: 162px;
			height: 46px;
			border-radius: 6px;
			text-align: center;
			line-height: 46px;
			font-size: 16px;
			cursor: pointer;
		}
		.b1{
			background: #E9F6FF;
			color: #3B6492;
		}
		.b2{
			background: #3B6492;
			color: #fff;
			margin-left: 14px;
		}
	}
}
</style>